import React, { Suspense } from 'react'

import Route from './Route'
import LoadingBar from 'react-top-loading-bar'
import NotFound from '@shared/layouts/NotFound'
import themes from '@config/themes'

import { Route as ReactDomRoute, Switch } from 'react-router-dom'
import { routes } from '@modules'

const Routes = () => {
  const loadingBarRef = React.useRef(null)

  const LoadingBarEffect = () => {
    React.useEffect(() => {
      loadingBarRef.current?.continuousStart()
      return () => {
        loadingBarRef.current?.complete()
      }
    }, [])

    return <></>
  }

  return (
    <>
      <LoadingBar
        ref={loadingBarRef}
        progress={0}
        color={themes.default.primary}
        waitingTime={100}
      />
      <Suspense fallback={<LoadingBarEffect />}>
        <Switch>
          {routes.map(
            ({ name, path, exact, meta, component: Component }) => {
              return (
                <Route
                  key={name}
                  path={path}
                  name={name}
                  exact={exact}
                  meta={meta}
                  component={Component}
                />
              )
            }
          )}
          <ReactDomRoute>
            <NotFound />
          </ReactDomRoute>
        </Switch>
      </Suspense>
    </>
  )
}

export default Routes
